<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>

<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">

            <!--breadcrumb-->
            <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                <div class="breadcrumb-title pe-3">Profile</div>
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href='javascript:void(0)' routerLink='/dashboard'><i class="bx bx-home-alt"></i></a></li>
                            <li class="breadcrumb-item active" aria-current="page">Profile</li>
                        </ol>
                    </nav>
                </div>
                <!-- <div class="ms-auto">
                    <div class="btn-group">
                        <button type="button" class="btn custom-btn dark-btn split-bg-primary dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown"> Settings </button>
                        <div class="dropdown-menu dropdown-menu-right dropdown-menu-lg-end"> <a class="dropdown-item" href="javascript: void(0);">Action</a>
                            <a class="dropdown-item" href="javascript: void(0);">Another action</a>
                            <a class="dropdown-item" href="javascript: void(0);">Something else here</a>
                            <div class="dropdown-divider"></div> <a class="dropdown-item" href="javascript: void(0);">Separated link</a>
                        </div>
                    </div>
                </div> -->
            </div>
            <!--end breadcrumb-->


            <div class="main-body" *ngIf="showhide">

                <div class="row">
                    <div class="col-lg-6">
                        <div class="card">
                            <div class="card-body">
                                <form [formGroup]="profileData">
                                    <div class="row mb-3">
                                        <div class="col-sm-3"></div>
                                        <div class="col-sm-9">
                                            <div class="d-flex py-3">
                                                <div *ngIf="imgURL ==''">
                                                    <label for="formFile" class="form-label">Upload image</label>
                                                    <input type="file" id="file1" class="form-control" name="image" accept="image/*" (change)="getUploadFileDetail($event)" style="cursor: pointer;" />
                                                </div>
                                                <div class="profile-img-box" *ngIf="imgURL !=''">
                                                    <div class="profile-img">
                                                        <img [src]="imgURL" alt="Admin">
                                                    </div>
                                                    <button type="button" class="profile-edit-btn" (click)="changeImage()">
                                                            <i class="bx bx-pencil"></i>
                                                        </button>
                                                    <input type="file" id="file1" class="form-control" name="image" accept="image/*" (change)="getUploadFileDetail($event)" style="cursor: pointer;display: none;" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-sm-3">
                                            <h6 class="mb-0">Full Name</h6>
                                        </div>
                                        <div class="col-sm-9 text-secondary">
                                            <input type="text" class="form-control" [(ngModel)]="loginDetail.fullName" formControlName="name" [ngClass]="{ 'is-invalid': submitted && f1.name.errors }">
                                            <small id="errorEmail" class="errormessage text-danger d-inline-block pt-2" *ngIf="submitted && f1.name.errors"> 
                                                    <div *ngIf="f1['name'].errors['required']">Full Name is required</div>                                        
                                                </small>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-sm-3">
                                            <h6 class="mb-0">Email</h6>
                                        </div>
                                        <div class="col-sm-9 text-secondary">
                                            <input type="text" class="form-control" [(ngModel)]="loginDetail.email" [ngModelOptions]="{standalone: true}" readonly disabled/>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-3"></div>
                                        <div class="col-sm-9 text-secondary">
                                            <input type="button" class="btn custom-btn gradient1-btn px-4" value="Save Changes" (click)="onSubmit()" />
                                        </div>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <form [formGroup]="SocailData">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <h5 class="d-flex align-items-center mb-3 py-3">Social Link</h5>
                                            <div class="row mb-3">
                                                <div class="col-sm-3">
                                                    <h6 class="mb-0">Phone</h6>
                                                </div>
                                                <div class="col-sm-9 text-secondary">
                                                    <input type="text" class="form-control" [(ngModel)]="datadetail.contactNumber" formControlName="contactNumber" [ngClass]="{ 'is-invalid': submitted && f.contactNumber.errors }">
                                                    <small id="errorEmail" class="errormessage text-danger d-inline-block pt-2" *ngIf="submitted && f.contactNumber.errors"> 
                                                        <div *ngIf="f['contactNumber'].errors['required']">Phone is required</div>                                        
                                                    </small>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-sm-3">
                                                    <h6 class="mb-0">Info Email</h6>
                                                </div>
                                                <div class="col-sm-9 text-secondary">
                                                    <input type="text" class="form-control" [(ngModel)]="datadetail.footerEmail" formControlName="footerEmail" [ngClass]="{ 'is-invalid': submitted && f.footerEmail.errors }">
                                                    <small id="errorEmail" class="errormessage text-danger d-inline-block pt-2" *ngIf="submitted && f.footerEmail.errors"> 
                                                    <div *ngIf="f['footerEmail'].errors['required']">Info Email is required</div>                                        
                                                </small>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-sm-3">
                                                    <h6 class="mb-0">Facebook</h6>
                                                </div>
                                                <div class="col-sm-9 text-secondary">
                                                    <input type="text" class="form-control" [(ngModel)]="datadetail.facebookUrl" formControlName="facebookUrl" [ngClass]="{ 'is-invalid': submitted && f.facebookUrl.errors }">
                                                    <small id="errorEmail" class="errormessage text-danger d-inline-block pt-2" *ngIf="submitted && f.facebookUrl.errors"> 
                                                    <div *ngIf="f['facebookUrl'].errors['required']">Facebook Url is required</div>                                        
                                                </small>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-sm-3">
                                                    <h6 class="mb-0">TikTok</h6>
                                                </div>
                                                <div class="col-sm-9 text-secondary">
                                                    <input type="text" class="form-control" [(ngModel)]="datadetail.tikTokUrl" formControlName="twitterUrl" [ngClass]="{ 'is-invalid': submitted && f.twitterUrl.errors }">
                                                    <small id="errorEmail" class="errormessage text-danger d-inline-block pt-2" *ngIf="submitted && f.twitterUrl.errors"> 
                                                    <div *ngIf="f['twitterUrl'].errors['required']">Twitter Url is required</div>                                        
                                                </small>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-sm-3">
                                                    <h6 class="mb-0">Linkedin</h6>
                                                </div>
                                                <div class="col-sm-9 text-secondary">
                                                    <input type="text" class="form-control" [(ngModel)]="datadetail.linkedinUrl" formControlName="pinterestUrl" [ngClass]="{ 'is-invalid': submitted && f.pinterestUrl.errors }">
                                                    <small id="errorEmail" class="errormessage text-danger d-inline-block pt-2" *ngIf="submitted && f.pinterestUrl.errors"> 
                                                    <div *ngIf="f['pinterestUrl'].errors['required']">LinkedIn Url is required</div>                                        
                                                </small>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-sm-3">
                                                    <h6 class="mb-0">Instagram</h6>
                                                </div>
                                                <div class="col-sm-9 text-secondary">
                                                    <input type="text" class="form-control" [(ngModel)]="datadetail.instagramUrl" formControlName="instagramUrl" [ngClass]="{ 'is-invalid': submitted && f.instagramUrl.errors }">
                                                    <small id="errorEmail" class="errormessage text-danger d-inline-block pt-2" *ngIf="submitted && f.instagramUrl.errors"> 
                                                    <div *ngIf="f['instagramUrl'].errors['required']">Instagram Url is required</div>                                        
                                                </small>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-sm-3"></div>
                                                <div class="col-sm-9 text-secondary">
                                                    <input type="button" class="btn custom-btn gradient1-btn px-4" value="Save Changes" (click)="onSubmit1()" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </div>

        </div>
    </div>
    <app-footer></app-footer>
</div>
